import classNames from "classnames";
import { Alert, Skeleton } from "antd";
import { ApolloQueryResult, ApolloError } from "@apollo/client";

import style from "./style.module.scss";

import { Arrow } from "../../components/Arrow";
import CardInterests from "../../components/CardInterests";

interface IMyInterests {
	loadingUserCheckouts: boolean;
	refetchUserCheckouts: (variables?: Record<string, any> | undefined) => Promise<ApolloQueryResult<any>>;
	errorUserCheckouts?: ApolloError;
	checkouts?: any;
	hidePopover?: () => void;
	activateRedirect: (e: React.MouseEvent) => void;
	setWasScrolled: React.Dispatch<React.SetStateAction<boolean>>;
	wasScrolled: boolean;
}

const MyInterestsList = ({
	loadingUserCheckouts,
	checkouts,
	refetchUserCheckouts,
	hidePopover,
	errorUserCheckouts,
	activateRedirect,
	setWasScrolled,
	wasScrolled,
}: IMyInterests): JSX.Element => {
	return loadingUserCheckouts ? (
		<Skeleton active avatar />
	) : checkouts?.checkouts?.length >= 1 ? (
		<>
			{checkouts?.checkouts
				?.filter((item) => item.order?.status === "paid")
				.map((e) => (
					<CardInterests
						styleInline={{
							borderBottom: "1px solid rgba(204, 200, 200, 0.75)",
						}}
						id={e.id}
						key={e.id}
						classId={e.class.id}
						courseName={e.class.name}
						addressCity={e.class.campus?.addressCity}
						addressState={e.class.campus?.addressState}
						level={e.class.course?.level}
						institutionLogo={e.class.institution?.logo}
						institutionName={e.class.institution?.name}
						classType={e.class.type}
						graduationType={e.class.courseInstitution?.graduationType}
						duration={e.class.courseInstitution?.duration}
						durationType={e.class.courseInstitution?.durationType}
						spot={e.class.availableSpots}
						typeButton="separate"
						campusName={e.class.campus?.name}
						shift={e.class.shift}
						refetch={refetchUserCheckouts}
						visiblePopover={hidePopover}
						courseId={e.class.course?.id}
						transactionStatus={e.order?.status}
						boletoUrl={e?.order?.boletoUrl}
						type="default"
						boletoExpirationDate={e?.order?.boletoExpirationDate}
						classOriginalPrice={e.class.originalPrice}
						classDiscount={e.class.discount}
						classPriceOriginalPrice={e.classPrice?.originalPrice}
						classPriceDiscount={e.classPrice?.discount}
						courseSlug={e.class.course?.slug}
						institutionSlug={e?.class.institution?.slug}
						setWasScrolled={setWasScrolled}
						wasScrolled={wasScrolled}
						isMatriculae={!!e.class?.isMatriculae}
						enrollmentStatus={e.order?.enrollmentStatus}
					/>
				))}
			<div className={style.headerInterests}>
				<h2>CONTRATAÇÕES NÃO FINALIZADAS</h2>
			</div>
			<p className={classNames(style.infoText, style.descriptionInterests)}>
				Você clicou em “Garantir Bolsa” mas não concluiu a contratação dessas ofertas:
			</p>
			{checkouts?.checkouts
				?.filter((item) => item.order?.status !== "paid")
				.map((e) => (
					<CardInterests
						id={e.id}
						key={e.id}
						classId={e.class.id}
						courseName={e.class.name}
						addressCity={e.class.campus?.addressCity}
						addressState={e.class.campus?.addressState}
						level={e.class.course?.level}
						institutionLogo={e.class.institution?.logo}
						institutionName={e.class.institution?.name}
						classType={e.class.type}
						graduationType={e.class.courseInstitution?.graduationType}
						duration={e.class.courseInstitution?.duration}
						durationType={e.class.courseInstitution?.durationType}
						spot={e.class.availableSpots}
						typeButton="separate"
						campusName={e.class.campus?.name}
						shift={e.class.shift}
						refetch={refetchUserCheckouts}
						visiblePopover={hidePopover}
						courseId={e.class.course?.id}
						transactionStatus={e.order?.status}
						boletoUrl={e?.order?.boletoUrl}
						type="default"
						boletoExpirationDate={e?.order?.boletoExpirationDate}
						classOriginalPrice={e.class.originalPrice}
						classDiscount={e.class.discount}
						classPriceOriginalPrice={e.classPrice?.originalPrice}
						classPriceDiscount={e.classPrice?.discount}
						courseSlug={e.class.course?.slug}
						institutionSlug={e?.class.institution?.slug}
						setWasScrolled={setWasScrolled}
						wasScrolled={wasScrolled}
						isMatriculae={!!e.class?.isMatriculae}
						enrollmentStatus={e.order?.enrollmentStatus}
					/>
				))}

			<p className={classNames(style.infoText, style.text)}>
				As bolsas de estudo possuem vagas limitadas. Caso você comece, mas não finalize a contratação, não podemos garantir a sua vaga.
			</p>

			{checkouts?.count > 5 && (
				<a href={"meus-interesses"} className={style.btnRight} onClick={hidePopover}>
					<span>Ver lista completa</span>
					<Arrow className={style.arrow} />
				</a>
			)}

			{errorUserCheckouts && <Alert type="error" message={errorUserCheckouts.message.replace("GraphQL error:", "")} />}
		</>
	) : (
		<>
			<p className={style.infoText}>
				Caso você inicie mas não finalize a contratação de uma bolsa, ela aparecerá aqui para você continuar de onde parou.
			</p>
			<button className={style.btnContinue} onClick={activateRedirect}>
				<span>Confira Bolsas de Estudo</span>
				<Arrow className={style.arrowContinue} />
			</button>
		</>
	);
};

export default MyInterestsList;
